/**
 * "Download" menu of a documentation page: the Markdown source straight from the loaded
 * content, and the Word document that the build pre-rendered into /downloads/.
 */
import {
    Menu,
    MenuButton,
    MenuItem,
    MenuItemLink,
    MenuList,
    MenuPopover,
    MenuTrigger,
} from '@fluentui/react-components';
import { ArrowDownloadRegular } from '@fluentui/react-icons';
import { saveAs } from 'file-saver';

type DownloadMenuProps = {
    /** Path of the page relative to the docs root, e.g. `db/claim.md`. */
    path: string;
    /** Raw Markdown source of the page. */
    content: string;
};

export function DownloadMenu({ path, content }: DownloadMenuProps) {
    const baseName = path.substring(path.lastIndexOf('/') + 1).replace(/\.md$/, '');
    const docxPath = path.replace(/\.md$/, '.docx');

    const handleMarkdownClick = () => {
        saveAs(new Blob([content], { type: 'text/markdown;charset=utf-8' }), `${baseName}.md`);
    };

    return (
        <Menu>
            <MenuTrigger disableButtonEnhancement>
                <MenuButton appearance="subtle" icon={<ArrowDownloadRegular />}>
                    Download
                </MenuButton>
            </MenuTrigger>
            <MenuPopover>
                <MenuList>
                    <MenuItem onClick={handleMarkdownClick}>Markdown (.md)</MenuItem>
                    <MenuItemLink href={`/downloads/${encodeURI(docxPath)}`} download={`${baseName}.docx`}>
                        Word (.docx)
                    </MenuItemLink>
                </MenuList>
            </MenuPopover>
        </Menu>
    );
}
